export class IntegerHelper {

    public static randomInteger(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min)
    };
}
